const uiActionTable = {
  content: 0,
  call: 1,
  email: 2,
  browser: 3,
  rsvp: 4,
};

const showExcept = (indexToShow, fields) => {
  fields.forEach((item, index) => {
    if (index !== indexToShow) {
      item.hide();
    } else {
      item.show();
    }
  });
};

const showIfPresent = (element) => {
  if (element) {
    $(element).show();
  }
};

const showUiFunction = (value, fields, callToActionField) => {
  switch (value) {
    case "content":
    case "call":
    case "email":
    case "browser":
    case "rsvp":
      showExcept(uiActionTable[value], fields);
      showIfPresent(callToActionField);
      break;
    default:
      if (callToActionField) {
        callToActionField.hide();
      }
      showExcept(100, fields);
  }
};

const setSubPageRequiredField = (value) => {
  if (value === "content") {
    $("#feature_post_ui_action_attributes_sub_page_attributes_title").attr(
      "required",
      true
    );
    // $("#feature_post_ui_action_attributes_sub_page_attributes_subtitle").attr(
    //   "required",
    //   true
    // );
  } else {
    $("#feature_post_ui_action_attributes_sub_page_attributes_title").attr(
      "required",
      false
    );
    // $("#feature_post_ui_action_attributes_sub_page_attributes_subtitle").attr(
    //   "required",
    //   false
    // );
  }
};

const onReset = (
  destroyField,
  destroyInfoPostField,
  resetButton,
  radioButtonContainer,
  fields,
  callToActionField
) => (event) => {
  destroyField.attr("value", true);
  resetButton.hide();
  fields.forEach((field) => $(field).hide());
  if (callToActionField) {
    callToActionField.hide();
  }
  if (destroyInfoPostField.length > 0) {
    destroyInfoPostField.attr("value", true);
  }
  radioButtonContainer.find("input[type='radio']").each((_, element) => {
    const ele = $(element);
    ele.attr("checked", null);
    ele.prop("checked", false);
  });
};

const onRadioButtonChecked = (
  fields,
  callToActionField,
  isSubPageDetailsRequired,
  destroyField,
  destroyInfoPostField,
  resetButton
) => (event) => {
  showUiFunction(event.target.value, fields, callToActionField);
  destroyField.attr("value", null);
  resetButton.show();
  if (isSubPageDetailsRequired) {
    setSubPageRequiredField(event.target.value);
  }
  if (destroyInfoPostField.length > 0) {
    if (event.target.value !== "post_items") {
      destroyInfoPostField.attr("value", true);
    } else {
      destroyInfoPostField.attr("value", null);
    }
  }
};

const bindUiActionToListeners = (
  selector,
  radioButtonsSelector,
  detailsSelector,
  hasCallToAction = true,
  hasSubPage = false,
  isSubPageDetailsRequired = false,
  isSubPage = false
) => {
  // can have many UI Action panels, such as Info Posts
  // can have only one or two.
  const uiActions = $(selector);

  uiActions.each((_, uiAction) => {
    const uiActionSelector = $(uiAction);
    const details = uiActionSelector.find(detailsSelector);

    // Ui Action Payload Fields
    const callField = details.find(".ui_action_payload_phone_no_field");
    const browserField = details.find(".ui_action_payload_url_field");
    const emailField = details.find(".ui_action_payload_email_address_field");
    const rsvpField = details.find(".ui_action_payload_campaign_field");
    const callToActionField = hasCallToAction
      ? details.find(".ui_action_call_to_action_field")
      : null;

    // Sub Page Container
    const subPageContentFields = hasSubPage
      ? uiActionSelector.find("#sub_page_contents")
      : $();

    const fields = [
      subPageContentFields,
      callField,
      emailField,
      browserField,
      rsvpField,
    ];

    const uiActionRadioButtonContainer = uiActionSelector.find(
      radioButtonsSelector
    );

    // Get enclosed Radio Buttons
    const uiActionTypeSelectionRadioButtons = uiActionRadioButtonContainer.find(
      "input[type='radio']"
    );

    // Reset button
    const resetButton = uiActionRadioButtonContainer.find(
      ".reset-ui_action-btn"
    );
    const destroyField = uiActionRadioButtonContainer.find(
      ".destroy_ui_action_field"
    );
    const destroyInfoPostField = isSubPage
      ? uiActionSelector.find(".destroy_info_posts_field")
      : $();

    uiActionTypeSelectionRadioButtons.change(
      onRadioButtonChecked(
        fields,
        callToActionField,
        isSubPageDetailsRequired,
        destroyField,
        destroyInfoPostField,
        resetButton
      )
    );

    // Look for checked button.
    const checkedUiActionTypeSelectionRadioButton = uiActionSelector.find(
      "input[type='radio']:checked"
    );

    // Only show corresponding selected field(s).
    if (checkedUiActionTypeSelectionRadioButton.length > 0) {
      showUiFunction(
        checkedUiActionTypeSelectionRadioButton.val(),
        fields,
        callToActionField
      );
      if (isSubPageDetailsRequired) {
        setSubPageRequiredField(checkedUiActionTypeSelectionRadioButton.val());
      }
    } else {
      // show nothing if nothing selected.
      resetButton.hide();
      showUiFunction(null, fields, callToActionField);
    }

    resetButton.click(
      onReset(
        destroyField,
        destroyInfoPostField,
        resetButton,
        uiActionRadioButtonContainer,
        fields,
        callToActionField
      )
    );
  });
};

// $('.main_ui_actions').find('input[type="radio"]:checked').each((index, ele) => { $(ele).attr("checked", null) })
// $('.main_ui_actions').find('input[type="radio"]:checked').each((index, ele) => { $(ele).attr("checked", null) })

$(document).ready(() => {
  // if this is for feautre post ui form
  if ($("#feature_post_ui_form").length > 0) {
    bindUiActionToListeners(
      ".main_ui_actions",
      ".main_ui_action_radio_buttons",
      ".main_ui_action_items",
      false,
      true,
      true
    );

    bindUiActionToListeners(
      "#sub_page_ui_actions",
      "#sub_page_ui_action_radio_buttons",
      "#sub_page_ui_action_items",
      true,
      false,
      false,
      true
    );
  }

  if ($("#info_posts").length > 0) {
    bindUiActionToListeners(
      ".main_ui_actions",
      ".main_ui_action_radio_buttons",
      ".main_ui_action_items"
    );

    // for info posts
    $("#info_posts").on(
      "cocoon:after-insert",
      (e, insertedItem, originalEvent) => {
        const uiActionPanel = $(insertedItem).find(".main_ui_actions");
        bindUiActionToListeners(
          uiActionPanel,
          ".main_ui_action_radio_buttons",
          ".main_ui_action_items"
        );
      }
    );
  }

  if ($("#info_post").length > 0) {
    bindUiActionToListeners(
      ".main_ui_actions",
      ".main_ui_action_radio_buttons",
      ".main_ui_action_items"
    );
  }
});
